<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { RowInfo, RowSlot } from '@shared/ui/other'
import { LinkTextPrimaryMedium } from '@shared/ui/links'
import { NativeSelect } from '@shared/ui/fields'
import { BtnToggle } from '@shared/ui/buttons'
import { AppBadge } from '@shared/ui/badges'

import DisciplineGeneralLinks from './DisciplineGeneralLinks.vue'
import DisciplineSubstituteTutors from './DisciplineSubstituteTutors.vue'
import { useDisciplineGeneralInfo } from '../model/discipline-general-info.hook'

defineOptions({
  name: 'DisciplineGeneralInfo',
})

const {
  canViewDisciplines,
  refStageOptions,
  refGradeOptions,
  refStage,
  refGrade,
  refIsManualAssign,
  refIsAdditionalPractice,
  refRegularTutorName,
  refRegularTutorUrl,
  refSubstituteTutors,
  refStudyStatus,
  refFirstLessonTime,
  refNextLessonTime,
  setStage,
  setGrade,
  toggleManualAssign,
  toggleAdditionalPractice,
} = useDisciplineGeneralInfo()
</script>

<template>
  <div class="discipline-general-info">
    <div class="discipline-general-info__column">
      <AppText name="body1-medium">
        General info
      </AppText>
      <RowSlot
        v-if="canViewDisciplines"
        label="Kanban stage"
      >
        <NativeSelect
          id="stage"
          name="stage"
          :value="refStage"
          :options="refStageOptions"
          placeholder-enabled
          placeholder="Select stage"
          @change="setStage"
        />
      </RowSlot>
      <RowSlot
        v-if="canViewDisciplines"
        label="Curriculum grade"
      >
        <NativeSelect
          id="curriculum_grade"
          name="curriculum_grade"
          :value="refGrade"
          :options="refGradeOptions"
          placeholder-enabled
          placeholder="Select grade"
          @change="setGrade"
        />
      </RowSlot>
      <RowInfo title="Regular tutor">
        <LinkTextPrimaryMedium
          v-if="refRegularTutorUrl"
          :href="refRegularTutorUrl"
        >
          {{ refRegularTutorName ?? '-' }}
        </LinkTextPrimaryMedium>
        <AppText
          v-else
          name="body1"
          color="red-600"
        >
          Unassigned tutor
        </AppText>
      </RowInfo>
      <RowInfo title="Substitute tutor">
        <DisciplineSubstituteTutors
          v-if="refSubstituteTutors.length"
          :tutors="refSubstituteTutors"
        />
        <AppText
          v-else
          name="body1"
        >
          -
        </AppText>
      </RowInfo>
      <RowInfo
        v-if="canViewDisciplines"
        title="Study status"
      >
        <AppBadge
          v-if="refStudyStatus"
          :color="refStudyStatus.color"
          :text="refStudyStatus.text"
        />
      </RowInfo>
      <RowInfo
        title="First lesson:"
        :value="refFirstLessonTime"
      />
      <RowInfo
        title="Next lesson:"
        :value="refNextLessonTime"
      />
      <RowSlot
        v-if="canViewDisciplines"
        label="Manual assign:"
      >
        <BtnToggle
          :checked="refIsManualAssign"
          @click="toggleManualAssign"
        />
      </RowSlot>
      <RowSlot
        v-if="canViewDisciplines"
        label="Additional practice:"
      >
        <BtnToggle
          :checked="refIsAdditionalPractice"
          @click="toggleAdditionalPractice"
        />
      </RowSlot>
    </div>
    <DisciplineGeneralLinks
      v-if="canViewDisciplines"
    />
  </div>
</template>

<style scoped lang="scss" src="./DisciplineGeneralInfo.scss" />
